<script setup lang="ts">
import { ECMSType, ECMSPage, EHomePageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

const advantages = ref<
	| {
			[key: string]: any
	  }[]
	| undefined
>()

const { getLocaleLang } = usei18nService()
const pageSections = inject<Ref<IHomePageSectionModel[]>>('pageSections')!

if (!pageSections) {
	try {
		const type = await ApiService.fetchPageSectionByName(ECMSType.SUBPAGE, ECMSPage.HOME, EHomePageSectionType.ADVANTAGES)
		if (type) advantages.value = type?.translations.find((t) => t.language === getLocaleLang())?.content
	} catch (error) {
		logger.log(error)
	}
}

watch(
	() => pageSections?.value,
	(newValue) => {
		if (newValue) {
			const section = newValue.find((section) => section.name === EHomePageSectionType.ADVANTAGES)
			if (section) {
				advantages.value = section.translations.find((t) => t.language === getLocaleLang())?.content
			}
		}
	},
	{ immediate: true, deep: true },
)
</script>

<template>
	<div class="advantages">
		<div v-for="(advantage, i) in advantages" :key="i" class="advantages__item">
			<div class="advantages__icon-wrap">
				<GlobalIcon class="advantages__icon" name="tick-circle" :width="28" />
			</div>
			<p class="advantages__text" v-html="advantage.text?.toUpperCase()"></p>
		</div>
	</div>
</template>

<style scoped lang="scss" src="./Advantages.scss"></style>
